import { apiSlice } from "../../app/api/apiSlice";

export const youtubeApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getChannelVideos: builder.query({
      query: ({ search = "", page = 1, limit = 25, isShort } = {}) => ({
        url: "/youtube/videos",
        params: { search, page, limit, isShort },
      }),
      providesTags: ["Video"],
    }),

    getRoadNotes: builder.query({
      query: () => "/road-notes",
      providesTags: ["RoadNote"],
    }),

    // FETCH SINGLE TRAVEL JOURNAL LOG BY ITS URL SLUG
    getRoadNoteBySlug: builder.query({
      query: (slug) => `/road-notes/${slug}`,
      providesTags: (result, error, slug) => [{ type: "RoadNote", id: slug }],
    }),

    createRoadNote: builder.mutation({
      query: (body) => ({
        url: "/road-notes",
        method: "POST",
        body,
      }),
      invalidatesTags: ["RoadNote"],
    }),

    // 🟢 NEW: UPDATE SYSTEM OVERWRITE MUTATION PIPELINE
    updateRoadNote: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/road-notes/${id}`,
        method: "PUT",
        body,
      }),
      // Evicts the main list cache and the single-item slug node cache simultaneously
      invalidatesTags: (result, error, { slug }) => [
        "RoadNote",
        { type: "RoadNote", id: slug },
      ],
    }),

    // 🟢 NEW: REMOVE SYSTEM DELETION MUTATION PIPELINE
    deleteRoadNote: builder.mutation({
      query: (id) => ({
        url: `/road-notes/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["RoadNote"],
    }),
  }),
});

export const {
  useGetChannelVideosQuery,
  useGetRoadNotesQuery,
  useGetRoadNoteBySlugQuery,
  useCreateRoadNoteMutation,
  useUpdateRoadNoteMutation, // 🟢 EXPORTED NEW MUTATION HOOK
  useDeleteRoadNoteMutation, // 🟢 EXPORTED NEW MUTATION HOOK
} = youtubeApiSlice;
